import Sidebar from './Sidebar'

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js